import React from "react";
import { connect } from "react-redux";
import { list } from "../actions";

const Summary = props => {
  const { data } = props;
  return (
    <div className="col-md-2">
      <div className="report-summary">
        <div className="summary-label"> {data[0]} </div>
        <div className="summary-value">
          {data[1]}
        </div>
      </div>
    </div>
  );
};

class Summaries extends React.Component {
  render() {
    const content = this.props.summaryData.map((data, idx) => (
      <Summary data={data} key={idx} />
    ));

    return (
      <div className="col-md-12">
        <div className="content-header">
          <span className="title">Membership Summary</span>
        </div>
        {content}
      </div>
    );
  }
}

class Report extends React.Component {
  componentDidMount() {
    this.props.fetchSummaries();
  }
  render() {
    const summaryData = this.props.summaryData || [];
    return (
      <div>
        <Summaries summaryData={summaryData} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    summaryData: state.reports.summaries
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchSummaries() {
      dispatch(list("report_summaries"));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Report);



// WEBPACK FOOTER //
// ./src/components/Reports.js